import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import update from 'immutability-helper';
import uuidv4 from 'uuid';
import { bindActionCreators } from 'redux';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { FormControl, Select, InputLabel } from '@material-ui/core';
import Icon from '@material-ui/core/Icon';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';
import Fade from '@material-ui/core/Fade';

//components:
import NeuriteGrid from '../../components/neurite_grid';
import DatePicker from '../../components/utils/DatePicker';

//actions:
import { navigate, openDialog, hideDialog } from '../../actions';
import {
    getMaquinasCentroOrigen,
    getMaquinasCentroDestino,
    moveMaquinaToCentroDestino,
} from '../../actions/maquina_detalle_actions';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    container: {
        margin: '145px auto 30px',
        height: 450,
        display: 'flex',
        flexDirection: 'column',
    },
    items: {
        display: 'flex',
        justifyContent: 'space-around',
    },
    select: {
        minWidth: 135,
        margin: '0 auto 15px',
    },
    centreButton: {
        display: 'flex',
        alignItems: 'center',
    },
    button: {
        display: 'flex',
        flexDirection: 'column',
    },
    label: {
        marginTop: 15,
        cursor: 'pointer',
    },
    gridContainer: {
        marginTop: 15,
        width: '44%',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    tooltip: {
        fontSize: 14,
        color: 'white',
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
});

class MoverMaquina extends Component {
    constructor(props) {
        super(props);
        this.state = {
            IdSelectedCentroOrigen: 1,
            IdSelectedCentroDestino: 1,
            fchaCambio: this.props.dia,
            rowsSelected: [],
            // disabledButton: false
        };
    }

    componentDidMount() {
        if (!this.props.user && config.AUTH) {
            this.props.navigate(''); //go to home page
            return;
        }

        this.props.getMaquinasCentroOrigen(this.state.IdSelectedCentroOrigen);
        this.props.getMaquinasCentroDestino(this.state.IdSelectedCentroDestino);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            prevState.IdSelectedCentroOrigen !==
            this.state.IdSelectedCentroOrigen ||
            this.props.refreshOrigen
        )
            this.props.getMaquinasCentroOrigen(
                this.state.IdSelectedCentroOrigen,
            );
        else if (
            prevState.IdSelectedCentroDestino !==
            this.state.IdSelectedCentroDestino ||
            this.props.refreshDestino
        ) {
            this.props.getMaquinasCentroDestino(
                this.state.IdSelectedCentroDestino,
            );

            if (this.props.moveSuccess) {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message:
                            'Máquinas movidas con éxito al centro ' +
                            this.props.centros.find(
                                c =>
                                    c.id ===
                                    parseInt(prevState.IdSelectedCentroDestino),
                            ).centro,
                    },
                    uuidv4(),
                    false,
                    'sm',
                );
            }
        }
    }

    handleChange = (event, field) => {
        this.setState({
            ...this.state,
            [field]: event.target.value ? event.target.value : 1,
        });
    };
    handleChangeDate = (event, field) => {
        this.setState({ ...this.state, [field]: event });
    };

    compareCentros = (a, b) => {
        if (a.centro < b.centro) return -1;
        if (a.centro > b.centro) return 1;
        return 0;
    };

    centroSelectList = () => {
        return [
            ...this.props.centros.filter(
                c => c.isGroup === false && c.activo === 1,
            ),
        ]
            .sort(this.compareCentros)
            .map(centro => {
                return (
                    <option key={centro.id} value={centro.id}>
                        {centro.centro}
                    </option>
                );
            });
    };

    handleSelection = rows => {
        this.setState({ rowsSelected: rows });
    };

    onclickButton = () => {
        if (this.disableButton()) {
            return true;
        } else {
            this.props.openDialog(
                'ConfirmationDialog',
                {
                    message:
                        '¿Desea mover las máquinas seleccionadas del centro ' +
                        this.props.centros.find(
                            c =>
                                c.id ===
                                parseInt(this.state.IdSelectedCentroOrigen),
                        ).centro +
                        ' al centro ' +
                        this.props.centros.find(
                            c =>
                                c.id ===
                                parseInt(this.state.IdSelectedCentroDestino),
                        ).centro +
                        '?',
                    acceptHandler: () => {
                        const maquinasIds = this.state.rowsSelected
                            ? this.state.rowsSelected.map(
                                index => this.props.maquinasOrigen[index].id,
                            )
                            : [];

                        if (maquinasIds)
                            this.props.moveMaquinaToCentroDestino(
                                maquinasIds,
                                this.state.IdSelectedCentroOrigen,
                                this.state.IdSelectedCentroDestino,
                                this.state.fchaCambio,
                            );

                        this.setState({ maquinasIds: [], rowsSelected: [] });
                    },
                },
                uuidv4(),
                false,
                'sm',
            );
        }
    };

    disableButton = () => {
        if (
            this.state.IdSelectedCentroOrigen !==
            this.state.IdSelectedCentroDestino &&
            this.state.rowsSelected.length &&
            this.state.fchaCambio !== undefined &&
            this.state.fchaCambio !== ''
        ) {
            return false;
        }

        return true;
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.container}>
                    {/* upper selects and date: */}
                    <div className={classes.items}>
                        <FormControl className={classes.select}>
                            <InputLabel>CENTRO ORIGEN</InputLabel>

                            <Select
                                native
                                value={this.state.IdSelectedCentroOrigen}
                                onChange={event =>
                                    this.handleChange(
                                        event,
                                        'IdSelectedCentroOrigen',
                                    )
                                }
                            >
                                {this.centroSelectList()}
                            </Select>
                        </FormControl>
                        <Tooltip
                            title="Fecha en la que se realiza el cambio"
                            TransitionComponent={Fade}
                            TransitionProps={{ timeout: 500 }}
                            classes={{ tooltip: this.props.classes.tooltip }}
                        >
                            <FormControl>
                                {/*  <TextField
                                    id={'fchaCambio'}
                                    label={'Fecha del Cambio:'}
                                    type="date2"
                                    value={this.state.fchaCambio}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => this.handleChange(event, 'fchaCambio')}
                                /> */}
                                <DatePicker
                                    label={'Fecha del Cambio:'}
                                    value={this.state.fchaCambio}
                                    onChange={event => {
                                        if (event && !isNaN(event)) {
                                            const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                            this.handleChangeDate(
                                                d.toISOString().slice(0, 10),
                                                'fchaCambio',
                                            )
                                        }
                                    }}
                                />
                            </FormControl>
                        </Tooltip>

                        <FormControl className={classes.select}>
                            <InputLabel>CENTRO DESTINO</InputLabel>

                            <Select
                                native
                                value={this.state.IdSelectedCentroDestino}
                                onChange={event =>
                                    this.handleChange(
                                        event,
                                        'IdSelectedCentroDestino',
                                    )
                                }
                            >
                                {this.centroSelectList()}
                            </Select>
                        </FormControl>
                    </div>

                    {/* grids and middlebutton: */}
                    <div className={classes.items}>
                        <div className={classes.gridContainer}>
                            {this.props.maquinasOrigen &&
                                !this.props.isLoadingOrigen ? (
                                    <NeuriteGrid
                                    id="a_m_m_1"
                                        columns={[
                                            {
                                                key: 'descr',
                                                name: 'Descripción',
                                                editable: true,
                                                dragable: false,
                                            },
                                            {
                                                key: 'regInterno',
                                                name: 'Reg. Interno',
                                                editable: true,
                                                dragable: false,
                                            },
                                            {
                                                key: 'tipo',
                                                name: 'Tipo',
                                                editable: false,
                                                dragable: false,
                                            },
                                            {
                                                key: 'modelo',
                                                name: 'Modelo',
                                                editable: true,
                                                dragable: false,
                                            },
                                        ]}
                                        rows={this.props.maquinasOrigen}
                                        enableSelection={true}
                                        height={350}
                                        buttonEdit={false}
                                        buttonDelete={false}
                                        buttonNew={false}
                                        enableFilter={true}
                                        onSelection={this.handleSelection}
                                    />
                                ) : (
                                    <div className={classes.spinnerContainer}>
                                        <CircularProgress
                                            className={classes.spinner}
                                            color="primary"
                                        />
                                    </div>
                                )}
                        </div>

                        {/* middle button: */}
                        <div className={classes.centreButton}>
                            <Tooltip
                                title="Mover máquinas de centro origen a centro destino en la fecha indicada"
                                TransitionComponent={Fade}
                                TransitionProps={{ timeout: 500 }}
                                classes={{
                                    tooltip: this.props.classes.tooltip,
                                }}
                            >
                                <div
                                    className={classes.button}
                                    onClick={() => {
                                        this.onclickButton();
                                    }}
                                >
                                    <Fab
                                        color="primary"
                                        disabled={this.disableButton()}
                                    >
                                        <Icon
                                            color={
                                                this.disableButton()
                                                    ? 'disabled'
                                                    : 'secondary'
                                            }
                                            className="material-icons"
                                        >
                                            label_important
                                        </Icon>
                                    </Fab>
                                    <InputLabel className={classes.label}>
                                        MOVER
                                    </InputLabel>
                                </div>
                            </Tooltip>
                        </div>

                        <div className={classes.gridContainer}>
                            {this.props.maquinasDestino &&
                                !this.props.isLoadingDestino ? (
                                    <NeuriteGrid
                                    id="a_m_m_2"
                                        columns={[
                                            {
                                                key: 'descr',
                                                name: 'Descripción',
                                                editable: true,
                                                dragable: false,
                                            },
                                            {
                                                key: 'regInterno',
                                                name: 'Reg. Interno',
                                                editable: true,
                                                dragable: false,
                                            },
                                            {
                                                key: 'tipo',
                                                name: 'Tipo',
                                                editable: true,
                                                dragable: false,
                                            },
                                            {
                                                key: 'modelo',
                                                name: 'Modelo',
                                                editable: true,
                                                dragable: false,
                                            },
                                        ]}
                                        rows={this.props.maquinasDestino}
                                        height={350}
                                        buttonEdit={false}
                                        buttonDelete={false}
                                        buttonNew={false}
                                    />
                                ) : (
                                    <div className={classes.spinnerContainer}>
                                        <CircularProgress
                                            className={classes.spinner}
                                            color="primary"
                                        />
                                    </div>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MoverMaquina.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    centros: PropTypes.array.isRequired,
    maquinasOrigen: PropTypes.array.isRequired,
    dia: PropTypes.string.isRequired,
    refreshOrigen: PropTypes.bool.isRequired,
    isLoadingOrigen: PropTypes.bool.isRequired,
    maquinasDestino: PropTypes.array.isRequired,
    refreshDestino: PropTypes.bool.isRequired,
    isLoadingDestino: PropTypes.bool.isRequired,
    moveSuccess: PropTypes.bool,
    //dispatch
    navigate: PropTypes.func.isRequired,
    getMaquinasCentroOrigen: PropTypes.func.isRequired,
    getMaquinasCentroDestino: PropTypes.func.isRequired,
    moveMaquinaToCentroDestino: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        centros: state.centros.centros,
        //maquinasOrigen:
        maquinasOrigen: state.moverMaquinasOrigen.maquinas,
        dia: state.centroDiaSelected.dia,
        refreshOrigen: state.moverMaquinasOrigen.refresh,
        isLoadingOrigen: state.moverMaquinasOrigen.isLoading,
        //maquinasDestino:
        maquinasDestino: state.moverMaquinasDestino.maquinas,
        refreshDestino: state.moverMaquinasDestino.refresh,
        isLoadingDestino: state.moverMaquinasDestino.isLoading,
        moveSuccess: state.moverMaquinasDestino.moveSuccess,
    };
}

function mapDispathToProps(dispatch) {
    return bindActionCreators(
        {
            navigate,
            openDialog,
            hideDialog,
            getMaquinasCentroOrigen,
            getMaquinasCentroDestino,
            moveMaquinaToCentroDestino,
        },
        dispatch,
    );
}

export default connect(
    mapStateToProps,
    mapDispathToProps,
)(withStyles(styles, { withTheme: true })(MoverMaquina));
